import { API_V2 } from '@/infra/http';
import * as Types from './services.types';

// getListOfServicesByLocationId
export const getServices = async (locationId: number, token?: string) =>
  API_V2.get<Types.ServicesResponse>(`/services`, { params: { locationId, token } }).then((response) => response.data);

export const getCharlyInfo = async (token: string | null) =>
  API_V2.get<Types.CharlyInfoResponse>(`charly_discount`, { params: { token } }).then((response) => response.data);
